import { jsx as _jsx } from "react/jsx-runtime";
import { HorizontalStepper } from './HorizontalStepper';
import { Orientation } from './types';
import { VerticalStepper } from './VerticalStepper';
export function Stepper(props) {
    const { orientation = Orientation.horizontal } = props;
    if (orientation === Orientation.vertical) {
        return _jsx(VerticalStepper, { ...props, orientation: Orientation.vertical });
    }
    return _jsx(HorizontalStepper, { ...props, orientation: Orientation.horizontal });
}
export { useStepper } from './hooks';
